<template>
  <section
    v-if="variants.v1 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="custom-container narrow-padding">
      <div class="y-gap-15 tw-text-center">
        <div class="col-auto">
          <h2>{{ vars.titleText }}</h2>
        </div>
        <div class="col-lg-6 col-md-9 tw-hidden lg:tw-block">
          <p>{{ vars.descriptionText }}</p>
        </div>
      </div>

      <div data-anim-wrap class="row y-gap-30 pt-60 md:pt-30 tw-hidden lg:tw-flex">
        <div class="col-lg-4 col-sm-6" v-for="(team, index) in teams" :key="index">
          <div :data-anim-child="`slide-left delay-${index + 1}`">
            <div>
              <library-image
                v-if="team.photo"
                :src="team.photo"
                :alt="team.title || team.name"
                :w-ratio="5"
                :h-ratio="7"
              />
            </div>
            <div class="tw-mt-4">
              <h6 :style="{ color: 'var(--c-secondary)' }">
                {{ team.role }}
              </h6>
            </div>
            <div class="mt-3">
              <h3>{{ team.name }}</h3>
            </div>
            <div class="mt-3">
              <p><span class="tw-text-[#BFA87E]">P:</span> {{ team.phone }}</p>
            </div>
            <div class="mt-3">
              <p><span class="tw-text-[#BFA87E]">M:</span> {{ team.mail }}</p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="relative mt-60 md:mt-40 sm:mt-20 v1-swiper-container lg:tw-hidden"
        data-anim="slide-left"
        ref="v1SwiperContainer"
      >
        <div class="swiper-wrapper">
          <div class="swiper-slide tw-flex tw-justify-center" v-for="(team, index) in teams" :key="`team-${index}`">
            <div class="teamCard tw-flex tw-max-w-xs tw-flex-col tw-overflow-hidden">
              <div>
                <library-image
                  v-if="team.photo"
                  :src="team.photo"
                  :alt="team.title || team.name"
                  :w-ratio="5"
                  :h-ratio="7"
                  image-class="tw-object-cover tw-w-full tw-h-auto"
                />
              </div>
              <div class="mt-1">
                <h6 class="tw-mt-1 tw-text-sm tw-text-[#BFA87E]">
                  {{ team.role }}
                </h6>
              </div>
              <div class="mt-3">
                <h3 class="tw-text-lg tw-font-semibold">{{ team.name }}</h3>
              </div>
              <div class="mt-3">
                <p><span class="tw-text-[#BFA87E]">P:</span> {{ team.phone }}</p>
              </div>
              <div class="mt-3">
                <p><span class="tw-text-[#BFA87E]">M:</span> {{ team.mail }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="tw-mt-8 tw-flex tw-justify-center tw-gap-8 max-lg:tw-items-center max-lg:tw-justify-center">
          <button
            class="-prev js-prev n-link arrow-button tw-z-10 tw-cursor-pointer tw-select-none tw-opacity-80 tw-transition-opacity tw-duration-300 tw-ease-in-out hover:tw-opacity-100"
            style="border: none !important"
            @click="slidePrevV1"
          >
            <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.4697 14.0303C10.1768 13.7374 10.1768 13.2626 10.4697 12.9697L15.2426 8.1967C15.5355 7.90381 16.0104 7.90381 16.3033 8.1967C16.5962 8.48959 16.5962 8.96447 16.3033 9.25736L12.0607 13.5L16.3033 17.7426C16.5962 18.0355 16.5962 18.5104 16.3033 18.8033C16.0104 19.0962 15.5355 19.0962 15.2426 18.8033L10.4697 14.0303ZM61 14.25H11V12.75H61V14.25Z"
                fill="#BFA87E"
              />
              <circle
                cx="13.5"
                cy="13.5"
                r="13"
                transform="matrix(-1 0 0 1 27 0)"
                stroke="#BFA87E"
                stroke-opacity="0.5"
              />
            </svg>
          </button>
          <button
            class="-next js-next n-link arrow-button tw-z-10 tw-cursor-pointer tw-select-none tw-opacity-80 tw-transition-opacity tw-duration-300 tw-ease-in-out hover:tw-opacity-100"
            style="border: none !important"
            @click="slideNextV1"
          >
            <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M50.5303 14.0303C50.8232 13.7374 50.8232 13.2626 50.5303 12.9697L45.7574 8.1967C45.4645 7.90381 44.9896 7.90381 44.6967 8.1967C44.4038 8.48959 44.4038 8.96447 44.6967 9.25736L48.9393 13.5L44.6967 17.7426C44.4038 18.0355 44.4038 18.5104 44.6967 18.8033C44.9896 19.0962 45.4645 19.0962 45.7574 18.8033L50.5303 14.0303ZM0 14.25H50V12.75H0V14.25Z"
                fill="#BFA87E"
              />
              <circle cx="47.5" cy="13.5" r="13" stroke="#BFA87E" stroke-opacity="0.5" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="layout-pt-lg layout-pb-lg relative"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="container">
      <div class="y-gap-15 tw-text-center">
        <div class="col-auto">
          <h2>{{ vars.titleText }}</h2>
        </div>
        <div class="col-lg-6 col-md-9 tw-hidden lg:tw-block">
          <p>{{ vars.descriptionText }}</p>
        </div>
      </div>

      <ul
        class="tw-mb-12 tw-mt-8 tw-flex tw-justify-center tw-gap-2 tw-text-center tw-uppercase min-[400px]:tw-gap-4 md:tw-gap-6"
      >
        <li
          v-for="(category, index) in ['wells', 'castle', 'somerton']"
          :key="index"
          @click="activeCategory = category"
        >
          <h6
            class="tw-cursor-pointer"
            style="color: #bfa87e !important"
            :class="activeCategory === category ? 'underline' : ''"
          >
            {{ category === 'wells' ? 'WELLS' : category === 'castle' ? 'CASTLE CARY' : 'SOMERTON' }}
          </h6>
        </li>
      </ul>

      <div class="relative v2-swiper-container" ref="v2SwiperContainer">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, idx) in activeCategory === 'wells'
              ? wells
              : activeCategory === 'castle'
                ? castles
                : somertons"
            :key="idx"
          >
            <div class="tw-flex tw-flex-col tw-overflow-hidden">
              <library-image
                v-if="item.photo"
                :src="item.photo"
                :alt="item.name"
                :w-ratio="5"
                :h-ratio="7"
                image-class="tw-object-cover tw-w-full tw-h-auto"
              />
              <div>
                <h6 class="tw-mt-1 tw-text-sm tw-text-[#BFA87E]">{{ item.role }}</h6>
                <h3 class="tw-mt-3 tw-text-lg tw-font-semibold">{{ item.name }}</h3>
                <p class="tw-mt-3"><span class="tw-text-accent">T:</span> {{ item.phone }}</p>
                <p class="tw-mt-3"><span class="tw-text-accent">M:</span> {{ item.mail }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tw-mt-8 tw-flex tw-justify-center tw-gap-8 md:tw-hidden">
        <div
          @click="slidePrevV2"
          class="arrow-button tw-z-10 tw-cursor-pointer tw-select-none tw-opacity-80 tw-transition-opacity tw-duration-300 tw-ease-in-out hover:tw-opacity-100"
        >
          <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.4697 14.0303C10.1768 13.7374 10.1768 13.2626 10.4697 12.9697L15.2426 8.1967C15.5355 7.90381 16.0104 7.90381 16.3033 8.1967C16.5962 8.48959 16.5962 8.96447 16.3033 9.25736L12.0607 13.5L16.3033 17.7426C16.5962 18.0355 16.5962 18.5104 16.3033 18.8033C16.0104 19.0962 15.5355 19.0962 15.2426 18.8033L10.4697 14.0303ZM61 14.25H11V12.75H61V14.25Z"
              fill="#BFA87E"
            />
            <circle
              cx="13.5"
              cy="13.5"
              r="13"
              transform="matrix(-1 0 0 1 27 0)"
              stroke="#BFA87E"
              stroke-opacity="0.5"
            />
          </svg>
        </div>
        <div
          @click="slideNextV2"
          class="arrow-button tw-z-10 tw-cursor-pointer tw-select-none tw-opacity-80 tw-transition-opacity tw-duration-300 tw-ease-in-out hover:tw-opacity-100"
        >
          <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M50.5303 14.0303C50.8232 13.7374 50.8232 13.2626 50.5303 12.9697L45.7574 8.1967C45.4645 7.90381 44.9896 7.90381 44.6967 8.1967C44.4038 8.48959 44.4038 8.96447 44.6967 9.25736L48.9393 13.5L44.6967 17.7426C44.4038 18.0355 44.4038 18.5104 44.6967 18.8033C44.9896 19.0962 45.4645 19.0962 45.7574 18.8033L50.5303 14.0303ZM0 14.25H50V12.75H0V14.25Z"
              fill="#BFA87E"
            />
            <circle cx="47.5" cy="13.5" r="13" stroke="#BFA87E" stroke-opacity="0.5" />
          </svg>
        </div>
      </div>
    </div>

    <div
      @click="slidePrevV2"
      class="arrow-button tw-absolute tw-left-10 tw-top-1/2 tw-z-10 tw-hidden tw--translate-y-1/2 tw-transform tw-cursor-pointer tw-select-none tw-opacity-80 tw-transition-opacity tw-duration-300 tw-ease-in-out hover:tw-opacity-100 md:tw-block"
    >
      <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.4697 14.0303C10.1768 13.7374 10.1768 13.2626 10.4697 12.9697L15.2426 8.1967C15.5355 7.90381 16.0104 7.90381 16.3033 8.1967C16.5962 8.48959 16.5962 8.96447 16.3033 9.25736L12.0607 13.5L16.3033 17.7426C16.5962 18.0355 16.5962 18.5104 16.3033 18.8033C16.0104 19.0962 15.5355 19.0962 15.2426 18.8033L10.4697 14.0303ZM61 14.25H11V12.75H61V14.25Z"
          fill="#BFA87E"
        />
        <circle cx="13.5" cy="13.5" r="13" transform="matrix(-1 0 0 1 27 0)" stroke="#BFA87E" stroke-opacity="0.5" />
      </svg>
    </div>
    <div
      @click="slideNextV2"
      class="arrow-button tw-absolute tw-right-10 tw-top-1/2 tw-z-10 tw-hidden tw--translate-y-1/2 tw-transform tw-cursor-pointer tw-select-none tw-opacity-80 tw-transition-opacity tw-duration-300 tw-ease-in-out hover:tw-opacity-100 md:tw-block"
    >
      <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M50.5303 14.0303C50.8232 13.7374 50.8232 13.2626 50.5303 12.9697L45.7574 8.1967C45.4645 7.90381 44.9896 7.90381 44.6967 8.1967C44.4038 8.48959 44.4038 8.96447 44.6967 9.25736L48.9393 13.5L44.6967 17.7426C44.4038 18.0355 44.4038 18.5104 44.6967 18.8033C44.9896 19.0962 45.4645 19.0962 45.7574 18.8033L50.5303 14.0303ZM0 14.25H50V12.75H0V14.25Z"
          fill="#BFA87E"
        />
        <circle cx="47.5" cy="13.5" r="13" stroke="#BFA87E" stroke-opacity="0.5" />
      </svg>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';
import Swiper from 'swiper';
import 'swiper/css';

export default defineNuxtComponent({
  name: 'OurTeam',
  mixins: [ComponentMixin],
  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      swiperV1: null,
      swiperV2: null,
      activeCategory: 'wells',
    };
  },
  computed: {
    teams(): any[] {
      return this.groupedVariables?.teams || [];
    },
    wells(): any[] {
      return this.groupedVariables?.wells || [];
    },
    castles(): any[] {
      return this.groupedVariables?.castles || [];
    },
    somertons(): any[] {
      return this.groupedVariables?.somertons || [];
    },
    ...mapState(useWebsiteStore, ['sidebarComponents']),
  },
  watch: {
    activeCategory() {
      this.$nextTick(() => {
        this.initV2Swiper();
      });
    },
  },
  mounted() {
    this.initV1Swiper();
    this.initV2Swiper();
  },
  methods: {
    initV1Swiper() {
      this.$nextTick(() => {
        const swiperContainer = this.$refs.v1SwiperContainer;
        if (swiperContainer) {
          this.swiperV1 = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            centeredSlides: true,
            watchOverflow: true,
            cssMode: true,
            breakpoints: {
              640: {
                slidesPerView: 1,
                spaceBetween: 0,
                centeredSlides: true,
              },
            },
          });
        }
      });
    },
    initV2Swiper() {
      if (this.swiperV2) {
        this.swiperV2.destroy();
      }

      this.$nextTick(() => {
        const swiperContainer = this.$refs.v2SwiperContainer;
        if (swiperContainer) {
          this.swiperV2 = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            breakpoints: {
              640: {
                slidesPerView: 1,
                spaceBetween: 16,
                centeredSlides: true,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            },
          });
        }
      });
    },
    slidePrevV1() {
      if (this.swiperV1) {
        this.swiperV1.slidePrev();
      }
    },
    slideNextV1() {
      if (this.swiperV1) {
        this.swiperV1.slideNext();
      }
    },
    slidePrevV2() {
      if (this.swiperV2) {
        this.swiperV2.slidePrev();
      }
    },
    slideNextV2() {
      if (this.swiperV2) {
        this.swiperV2.slideNext();
      }
    },
  },
});
</script>

<style scoped>
.narrow-padding {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.custom-container {
  width: 75%;
  margin: 0 auto;
  position: relative;
}
.tw-text-accent {
  color: #bfa87e !important;
}
.arrow-button {
  background: transparent;
  border: none;
  cursor: pointer;
}

.v1-swiper-container {
  width: 100%;
  overflow: hidden;
}
.v1-swiper-container .swiper-wrapper {
  overflow: hidden !important;
}
.v1-swiper-container .swiper-slide {
  display: flex;
  justify-content: center;
  width: 100% !important;
}
.v1-swiper-container .teamCard {
  max-width: 100%;
  width: 100%;
}

.v2-swiper-container {
  width: 100%;
  overflow: hidden;
}
.arrow-button svg circle {
  transition: stroke-opacity 0.3s ease;
}
.arrow-button:hover svg circle {
  stroke-opacity: 1;
}
</style>
